import { DataProvider } from 'assets/providers/data/DataProvider';
import ErrorPage from 'assets/templates/errorPage/ErrorPage';
import { financeHomeRoute, HttpStatus } from 'config/Api.Config';
import useAccountReceivable, { AccountReceivableAction } from './Finance.AccountReceivable.Hooks';
import FinanceAccountReceivableDelete from './sections/Finance.AccountReceivable.Delete';
import FinanceAccountReceivableEdit from './sections/Finance.AccountReceivable.Edit';
import FinanceAccountReceivableImport from './sections/Finance.AccountReceivable.Import';
import FinanceAccountReceivableInfo from './sections/Finance.AccountReceivable.Info';
import FinanceAccountReceivableList from './sections/Finance.AccountReceivable.List';

export const financeAccountReceivableIndexRoute = financeHomeRoute + '/accountReceivable/:action?/:id?';

export default function FinanceAccountReceivableIndex() {
  const accountReceivableHook = useAccountReceivable();

  if (!accountReceivableHook.canView) return <ErrorPage status={HttpStatus.unauthorized} />;

  return (
    <DataProvider
      data={accountReceivableHook}
      render={({ pageRouter }) => {
        return (
          <>
            {pageRouter.params?.id && pageRouter.params.action === AccountReceivableAction.INFO ? (
              <FinanceAccountReceivableInfo />
            ) : (
              <FinanceAccountReceivableList />
            )}
            {pageRouter.params?.id && pageRouter.params.action === AccountReceivableAction.EDIT && (
              <FinanceAccountReceivableEdit />
            )}
            {pageRouter.params?.id && pageRouter.params.action === AccountReceivableAction.DELETE && (
              <FinanceAccountReceivableDelete />
            )}
            {pageRouter.params.action === AccountReceivableAction.IMPORT && <FinanceAccountReceivableImport />}
            {pageRouter.params.action === AccountReceivableAction.CREATE && <FinanceAccountReceivableEdit />}
          </>
        );
      }}
    />
  );
}
